import Button from 'app/components/button';
import HeaderWithBackButton from 'app/components/HeaderWithBackButton';
import NewAttachment from 'app/components/NewAttachment';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import AddUser from 'assets/images/ic-users-add.svg';
import CustomTable from './table';
import useCreateMenu from './useCreateMenu';
const CreateMenu = () => {
  const {
    handleDelete,
    addImage,
    imageUploadArray,
    menuImagesArray,
    handleCreateMenu,
    pageLoading,
    uploadMediaHandler,
    navigate,
  } = useCreateMenu();

  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <div className='content-container__actionBox'>
          <div className='content-container__filterSearch'>
            <HeaderWithBackButton title={'Menu'} goTo={APP_CONSTANTS.STORE} />
          </div>
          <Button
            isDisabled={
              imageUploadArray?.length + menuImagesArray?.length > 10
                ? true
                : false
            }
            onClick={addImage}
            className='content-container__filter-btn'
          >
            {' '}
            <img
              src={AddUser}
              alt='Add user'
              width='25'
              height='25'
              className='mr-5'
            />
            Add Image
          </Button>
        </div>

        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4 mt-4 '>
          <div className='wd-50'>
            <label>Add Menu Images*</label>

            {imageUploadArray?.map((item, index) => {
              return (
                <div className='mb-1 mb-4 mt-4 d-flex'>
                  <div>
                    <NewAttachment
                      value={item?.menu}
                      id='menu'
                      onFileSelected={(file) =>
                        uploadMediaHandler(file, 'menu', item.addid, index)
                      }
                      fileType='image'
                      label='Add Logo Image'
                      errorText={item?.error}
                      parentCross={true}
                      dimesnsionLabel='(375*230)'
                    />
                  </div>
                  <div>
                    <div
                      style={{ marginLeft: '10px', marginTop: '10px' }}
                      className='table-menu'
                    >
                      <Button
                        className=' cancel-button'
                        onClick={() => {
                          uploadMediaHandler(null, 'menu', item.addid, index);
                        }}
                        variant='Cancel'
                        name='Remove'
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>{' '}
        </div>
        {imageUploadArray?.length !== 0 && (
          <div className='d-flex justify-content-start mb-2'>
            <Button
              className='mt1'
              onClick={handleCreateMenu}
              variant='Save'
              name='Submit'
              isDisabled={imageUploadArray?.length === 0 ? true : false}
            />
            <Button
              className='mt1 cancel-button ms-2'
              onClick={() => navigate(APP_CONSTANTS.STORE)}
              variant='Cancel'
              name='Cancel'
              isDisabled={pageLoading ? true : false}
            />
          </div>
        )}

        <CustomTable
          data={menuImagesArray}
          getContentDataHandler={handleDelete}
        />
      </div>
    </div>
  );
};

export default CreateMenu;
